import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js';
import { FiHome, FiGrid, FiUsers, FiMessageSquare, FiUser, FiSettings, FiVideo, FiMonitor } from 'react-icons/fi';

const Sidebar = () => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  // Don't render sidebar when loading
  if (loading) return null;

  const sidebarItems = [
    { name: 'Home', path: '/', icon: <FiHome className="mr-2" /> },
    { name: 'Browse', path: '/browse', icon: <FiGrid className="mr-2" /> },
    { name: 'Categories', path: '/categories', icon: <FiGrid className="mr-2" /> },
    { name: 'Teams', path: '/teams', icon: <FiUsers className="mr-2" /> },
    { name: 'Community', path: '/community', icon: <FiMessageSquare className="mr-2" /> },
    { name: 'Tournaments', path: '/tournaments', icon: <FiUsers className="mr-2" /> },
  ];

  // Check if the current path matches the link path
  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <aside className="h-screen bg-[#0e0e10] text-white overflow-y-auto border-r border-gray-800 sticky top-12 left-0">
      <div className="px-2 py-3">
        {/* Main Navigation */}
        <div className="mb-2 px-2">
          <h3 className="text-sm font-semibold text-harmony-white mb-2">MAIN</h3>
        </div>
        <ul>
          {sidebarItems.map((item) => (
            <li key={item.name} className="mb-1">
              <Link 
                to={item.path}
                className={`flex items-center p-2 rounded font-medium 
                  ${isActive(item.path) 
                    ? 'bg-harmony-orange text-white' 
                    : 'text-gray-300 hover:bg-gray-700/50 hover:text-harmony-white'
                  } 
                  transition-colors`}
              >
                {item.icon} {item.name}
              </Link>
            </li>
          ))}
        </ul>
        
        {currentUser && (
          <>
            <div className="mt-6 mb-2 px-2">
              <h3 className="text-sm font-semibold text-harmony-white mb-2">PERSONAL</h3>
            </div>
            <ul>
              <li className="mb-1">
                <Link 
                  to="/profile" 
                  className={`flex items-center p-2 rounded font-medium 
                    ${isActive('/profile') 
                      ? 'bg-harmony-orange text-white' 
                      : 'text-gray-300 hover:bg-gray-700/50 hover:text-harmony-white'
                    } 
                    transition-colors`}
                >
                  <FiUser className="mr-2" /> Profile
                </Link>
              </li>
              <li className="mb-1">
                <Link 
                  to="/settings" 
                  className={`flex items-center p-2 rounded font-medium 
                    ${isActive('/settings') 
                      ? 'bg-harmony-orange text-white' 
                      : 'text-gray-300 hover:bg-gray-700/50 hover:text-harmony-white'
                    } 
                    transition-colors`}
                >
                  <FiSettings className="mr-2" /> Settings
                </Link>
              </li>
              <li className="mb-1">
                <Link 
                  to="/stream-settings" 
                  className={`flex items-center p-2 rounded font-medium 
                    ${isActive('/stream-settings') 
                      ? 'bg-harmony-orange text-white' 
                      : 'text-gray-300 hover:bg-gray-700/50 hover:text-harmony-white'
                    } 
                    transition-colors`}
                >
                  <FiVideo className="mr-2" /> Stream Settings
                </Link>
              </li>
              <li className="mb-1">
                <Link 
                  to="/stream-manager" 
                  className={`flex items-center p-2 rounded font-medium 
                    ${isActive('/stream-manager') 
                      ? 'bg-harmony-orange text-white' 
                      : 'text-gray-300 hover:bg-gray-700/50 hover:text-harmony-white'
                    } 
                    transition-colors`}
                >
                  <FiMonitor className="mr-2" /> Stream Manager
                </Link>
              </li>
            </ul>
          </>
        )}

        {/* Followed Channels would go here for a Twitch-like sidebar */}
        {currentUser && (
          <>
            <div className="mt-6 mb-2 px-2">
              <h3 className="text-sm font-semibold text-harmony-white mb-2">FOLLOWED CHANNELS</h3>
            </div>
            <ul className="text-gray-300">
              {/* This would be dynamically generated */}
              <li className="flex items-center p-2 hover:bg-gray-700/50 rounded">
                <div className="w-6 h-6 rounded-full bg-green-500 mr-2 flex-shrink-0"></div>
                <span className="truncate">Featured Streamer</span>
                <span className="ml-auto text-xs">1.2K</span>
              </li>
              <li className="flex items-center p-2 hover:bg-gray-700/50 rounded">
                <div className="w-6 h-6 rounded-full bg-green-500 mr-2 flex-shrink-0"></div>
                <span className="truncate">Top Player</span>
                <span className="ml-auto text-xs">892</span>
              </li>
              <li className="flex items-center p-2 hover:bg-gray-700/50 rounded">
                <div className="w-6 h-6 rounded-full bg-gray-600 mr-2 flex-shrink-0"></div>
                <span className="truncate opacity-70">Offline Channel</span>
              </li>
            </ul>
          </>
        )}
      </div>
    </aside>
  );
};

export default Sidebar; 